
<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseEdit from '@shared_components/base_edit.vue';

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = this.entry;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_GOAL_ITEMS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            harvestId: this.editableEntry.harvestId,
            customerId: this.editableEntry.customerId,
          }
        })
        .then(response => {
          this.editableEntry.itemGoals = response.data.accountContext.itemGoalsJson;
          // console.log("resp", response.data.accountContext.itemGoalsJson);
          // console.log("edit entry", this.editableEntry.itemGoals);
          this.editableEntry.previousHarvestId = null;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateServerEntry: function(goal) {
      this.pageLoading = true;
      console.log("up en", this.extraData);
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(goal, this.extraData.accountContext.goal.validations);
      filtered.itemGoals.forEach(element => {
        delete element.code;
        delete element.item;
        delete element.goalTotalPrice;
        delete element.totalPrice;
        delete element.price;
        delete element.volume;
        delete element.previousQuantity;
        delete element.previousSalePrice;
        delete element.__typename;
        element.itemGoals.forEach(item => {
          delete item.__typename;
          delete item.id;
          delete item.packaging;
          delete item.price;
          delete item.totalPrice;
          delete item.volume;
          delete element.previousQuantity;
          delete element.previousSalePrice;
          item.quantity = parseFloat(item.quantity);
          // delete item.item;
        });
      });
      // console.log("up", filtered);
      this.$apollo
        .mutate({
          mutation: UPDATE_GOAL_MUTATION,
          variables: {
            input: filtered,
          }
        })
        .then(response => {
          var errors = response.data.createGoal.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_GOAL_ITEMS_QUERY = gql `
  query($harvestId: ID!, $customerId: ID!){
    accountContext{
      goal {
        id
        validations
      }
      itemGoalsJson(harvestId: $harvestId, customerId: $customerId){
        itemId
        goalTotalPrice
        previousQuantity
        previousSalePrice
        volume
        item{
          id
          name
          brand{
            id
            name
          }
          unit{
            id
            name
          }
        }
        itemGoals{
          totalPrice
          price
          quantity
          packagingId
          packaging{
            name
            size
          }
        }
      }
      allHarvests{
        name
        id
      }
      allMyCustomers{
        id
        name
      }
    }
  }
`;

const UPDATE_GOAL_MUTATION = gql `
  mutation($input: GoalCreateInputObject!) {
    createGoal(input: $input) {
      goal {  
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

